import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Rx'
import 'rxjs/add/operator/skip';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Customer } from './Customer';

@Component({
  selector: 'app-dataservice',
  templateUrl: './dataservice.component.html',
  styleUrls: ['./dataservice.component.css']
})



export class DataserviceComponent implements OnInit {

  constructor(private route: ActivatedRoute, private httpService: HttpClient, private cookieService: CookieService) {


    
    if (window.location.search.substring(1).toString().indexOf('loc') == -1) {
      //if no query string then check if cookie preferance exists.
      if (this.cookieService.get('lang') == 'fr')
        this.loc = 'fr'
      else
        this.loc = 'en'

      this.LoadContent();
    }

    this.route.queryParams.skip(1).subscribe(params => {
      this.loc = params["loc"];
      this.LoadContent();
    });

  }

  public ngOnInit() {


  }

  ngAfterViewInit() {
  }

  public loc = 'en';
  public arrTranslations: Customer;

  httpOptions: any = {
    headers: new HttpHeaders({
      'Accept': 'application/json; charset=UTF-8',
      'Access-Control-Allow-Origin': '*'
      
    })
  };

  LoadContent() {

    if (this.loc == 'fr') {
      this.httpService.get('./assets/FR.json', this.httpOptions).subscribe(
        data => {
          console.log(data);
          this.arrTranslations = data as any;
          //alert(this.arrTranslations[0].firstname);
          //alert(this.arrTranslations[0].firstname);
          // FILL THE ARRAY WITH DATA.        
        },
        (err: HttpErrorResponse) => {
          console.log(err.message);
        }
      );
    }
    else {
      this.httpService.get('./assets/EN.json', this.httpOptions).subscribe(
        data => {
          //console.log(data);
          this.arrTranslations = data as any;
          //alert(this.arrTranslations[0].firstname);
          //alert(this.arrTranslations[0].firstname);
          // FILL THE ARRAY WITH DATA.        
        },
        (err: HttpErrorResponse) => {
          console.log(err.message);
        }
      );

    }
  }

}
